import * as types from './mutations-types';
import { set } from 'lodash-es';
import { clientApi } from '@phoenix/clientApi';

const initialState = {
  csrfToken: null,
  customerInfo: null,
  dynamicFields: {},
  error: null,
  currentCountry: null,
  hasGooglePlacesLoaded: false,
};

const getters = {
  csrfToken: (state) => state.csrfToken,
};

const actions = {
  setCsrfToken({ commit }, token) {
    commit(types.FORM_CSRF_TOKEN_SUCCESS, token);
  },

  async loadDynamicFields({ commit, state }, countryCode) {
    if (countryCode !== state.currentCountry && !state.dynamicFields[countryCode]) {
      commit(types.FORM_LOAD_DYNAMIC_FIELDS_REQUEST, countryCode);
      const { data } = await clientApi.get(window.route('api.form.dynamicFields', { countryCode }));
      commit(types.FORM_LOAD_DYNAMIC_FIELDS_SUCCESS, data.dynamicFields);
    }
  },
};

const mutations = {
  [types.FORM_CSRF_TOKEN_SUCCESS](state, token) {
    state.csrfToken = token;
  },

  [types.FORM_ERROR](state, error) {
    state.error = error;
  },

  [types.FORM_LOAD_DYNAMIC_FIELDS_REQUEST](state, currentCountry) {
    state.currentCountry = currentCountry;
  },

  [types.FORM_LOAD_DYNAMIC_FIELDS_SUCCESS](state, dynamicFields) {
    set(state, ['dynamicFields', state.currentCountry], dynamicFields);
  },

  [types.FORM_SET_HAS_GOOGLE_PLACES_LOADED](state, value) {
    set(state, ['hasGooglePlacesLoaded'], value);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
